import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { Dropdown, DropdownListItem, useBreakpoint } from "@brg/ui";
import { useMemo } from "react";
import { CreateLinkTo, LinkTo } from "../../../constants/linkTo";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next"
import { API } from "@brg/api";

export const COUNTRIES = [
  {
    name: [
      {name: 'армения', lang: 'ru'},
      {name: 'armenia', lang: 'en'},
    ],
    value: 'armenia',
  },
  {
    name: [
      {name: 'узбекистан', lang: 'ru'},
      {name: 'uzbekistan', lang: 'en'},
    ],
    value: 'uzbekistan',
  },
  {
    name: [
      {name: 'индия', lang: 'ru'},
      {name: 'india', lang: 'en'},
    ],
    value: 'india',
  },
  {
    name: [
      {name: 'казахстан', lang: 'ru'},
      {name: 'kazakhstan', lang: 'en'},
    ],
    value: 'kazakhstan',
  },
  {
    name: [
      {name: 'беларусь', lang: 'ru'},
      {name: 'belarus', lang: 'en'},
    ],
    value: 'belarus',
  },
  {
    name: [
      {name: 'киргизия', lang: 'ru'},
      {name: 'kyrgyzstan', lang: 'en'},
    ],
    value: 'kyrgyzstan',
  },
  {
    name: [
      {name: 'молдова', lang: 'ru'},
      {name: 'moldova', lang: 'en'},
    ],
    value: 'moldova',
  },
  {
    name: [
      {name: 'китай', lang: 'ru'},
      {name: 'china', lang: 'en'},
    ],
    value: 'china',
  },
  {
    name: [
      {name: 'абхазия', lang: 'ru'},
      {name: 'abkhazia', lang: 'en'},
    ],
    value: 'abkhazia',
  },
  {
    name: [
      {name: 'азербайджан', lang: 'ru'},
      {name: 'azerbaijan', lang: 'en'},
    ],
    value: 'azerbaijan',
  },
  {
    name: [
      {name: 'вьетнам', lang: 'ru'},
      {name: 'vietnam', lang: 'en'},
    ],
    value: 'vietnam',
  },
  {
    name: [
      {name: 'туркменистан', lang: 'ru'},
      {name: 'turkmenistan', lang: 'en'},
    ],
    value: 'turkmenistan',
  },
  {
    name: [
      {name: 'латвия', lang: 'ru'},
      {name: 'latvia', lang: 'en'},
    ],
    value: 'latvia',
  }
];


const useDafesTabs = () => {
  const history = useHistory();
  const { t, i18n: { language } } = useTranslation()
  const isCountriesPage = !!useRouteMatch(LinkTo.country);
  const isTablet = useBreakpoint(1200);

  const translatedItems = useMemo(() => {
    return API.lang(COUNTRIES, language);
  }, [language])

  if (isTablet) {
    return [];
  }

  return {
    [NAVBAR_TAB_NAMES.countries]: {
      active: isCountriesPage,
      content:   <Dropdown
        hideArrow
        maxWidth={300}
        orientation='left'
        target={
          <>
          {t('nav.countries')}
          </>
        }
      >
        {/* @ts-ignore */}
        {translatedItems.map((item, idx) => {
          return (
            <DropdownListItem
              // @ts-ignore
              dataName={item.name}
              data-title={item.name}
              onClick={() => history.push(CreateLinkTo.country(item.value))}
              key={idx}
            >
              {item.name}
            </DropdownListItem>
          )
        })}
      </Dropdown>
    }
  }
}

export default useDafesTabs;import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";
import { Dropdown, DropdownListItem, useBreakpoint } from "@brg/ui";
import { useMemo } from "react";
import { CreateLinkTo, LinkTo } from "../../../constants/linkTo";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next"
import { API } from "@brg/api";

export const COUNTRIES = [
  {
    name: [
      {name: 'армения', lang: 'ru'},
      {name: 'armenia', lang: 'en'},
    ],
    value: 'armenia',
  },
  {
    name: [
      {name: 'узбекистан', lang: 'ru'},
      {name: 'uzbekistan', lang: 'en'},
    ],
    value: 'uzbekistan',
  },
  {
    name: [
      {name: 'индия', lang: 'ru'},
      {name: 'india', lang: 'en'},
    ],
    value: 'india',
  },
  {
    name: [
      {name: 'казахстан', lang: 'ru'},
      {name: 'kazakhstan', lang: 'en'},
    ],
    value: 'kazakhstan',
  },
  {
    name: [
      {name: 'беларусь', lang: 'ru'},
      {name: 'belarus', lang: 'en'},
    ],
    value: 'belarus',
  },
  {
    name: [
      {name: 'киргизия', lang: 'ru'},
      {name: 'kyrgyzstan', lang: 'en'},
    ],
    value: 'kyrgyzstan',
  },
  {
    name: [
      {name: 'молдова', lang: 'ru'},
      {name: 'moldova', lang: 'en'},
    ],
    value: 'moldova',
  },
  {
    name: [
      {name: 'китай', lang: 'ru'},
      {name: 'china', lang: 'en'},
    ],
    value: 'china',
  },
  {
    name: [
      {name: 'абхазия', lang: 'ru'},
      {name: 'abkhazia', lang: 'en'},
    ],
    value: 'abkhazia',
  },
  {
    name: [
      {name: 'азербайджан', lang: 'ru'},
      {name: 'azerbaijan', lang: 'en'},
    ],
    value: 'azerbaijan',
  },
  {
    name: [
      {name: 'вьетнам', lang: 'ru'},
      {name: 'vietnam', lang: 'en'},
    ],
    value: 'vietnam',
  },
  {
    name: [
      {name: 'туркменистан', lang: 'ru'},
      {name: 'turkmenistan', lang: 'en'},
    ],
    value: 'turkmenistan',
  },
  {
    name: [
      {name: 'латвия', lang: 'ru'},
      {name: 'latvia', lang: 'en'},
    ],
    value: 'latvia',
  }
];


const useDafesTabs = () => {
  const history = useHistory();
  const { t, i18n: { language } } = useTranslation()
  const isCountriesPage = !!useRouteMatch(LinkTo.country);
  const isTablet = useBreakpoint(1200);

  const translatedItems = useMemo(() => {
    return API.lang(COUNTRIES, language);
  }, [language])

  if (isTablet) {
    return [];
  }

  return {
    [NAVBAR_TAB_NAMES.countries]: {
      active: isCountriesPage,
      content:   <Dropdown
        hideArrow
        maxWidth={300}
        orientation='left'
        target={
          <>
          {t('nav.countries')}
          </>
        }
      >
        {/* @ts-ignore */}
        {translatedItems.map((item, idx) => {
          return (
            <DropdownListItem
              // @ts-ignore
              dataName={item.name}
              data-title={item.name}
              onClick={() => history.push(CreateLinkTo.country(item.value))}
              key={idx}
            >
              {item.name}
            </DropdownListItem>
          )
        })}
      </Dropdown>
    }
  }
}

export default useDafesTabs;